import { useData } from "../data/DataContext";
import { ContentHeader } from "../components/ContentHeader";
import { EntityCard } from "../components/EntityCard";
import { OPERATIONS, ESTATES } from "../nav";

export function IntegrationsTab() {
  const data = useData();
  const items = (data.commandCenter?.estates.integrations ?? []).slice().sort((a, b) => a.name.localeCompare(b.name));
  const meta = ESTATES.find((e) => e.id === "integrations") ?? OPERATIONS[0];
  return (
    <>
      <ContentHeader title={meta.label} count={items.length} description={meta.desc} />
      <div className="grid">{items.map((it) => <EntityCard key={it.id} item={it} />)}</div>
    </>
  );
}
